/* tslint:disable */
/* eslint-disable */
/**
 * ITA_Rooming_Scaffold
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApplicationInfo,
    ApplicationInfoFromJSON,
    ApplicationInfoToJSON,
} from '../models';

/**
 * 
 */
export class ApplicationInfoApi extends runtime.BaseAPI {

    /**
     */
    async apiApplicationInfoGetRaw(): Promise<runtime.ApiResponse<ApplicationInfo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ApplicationInfo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationInfoFromJSON(jsonValue));
    }

    /**
     */
    async apiApplicationInfoGet(): Promise<ApplicationInfo> {
        const response = await this.apiApplicationInfoGetRaw();
        return await response.value();
    }

}
